import * as React from 'react';
import Logo from "./logo";
import Menu from "./menu";

import * as classess from '@styles/header.module.css';

const Header = () => {
    return(
        <header className={classess.header}>
            <Logo />
            <Menu />
        </header>
    )
}

export default Header;